// version 2.0

import { AnyObject } from '@triare/auth-redux';

export function getDataInStorage(name: string): AnyObject {
  try {
    return JSON.parse(localStorage.getItem(name) || '{}');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`localStorage: ${name}`, error);
  }

  return {};
}

export function getDataInSessionStorage(name: string): AnyObject {
  try {
    return JSON.parse(sessionStorage.getItem(name) || '{}');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`sessionStorage: ${name}`, error);
  }

  return {};
}

export function setDataInStorage(name: string, data: AnyObject, marge = false): void {
  let newData = data;

  if (marge) {
    const oldData = getDataInStorage(name);

    newData = { ...oldData, ...data };
  }

  let str = '';

  try {
    str = JSON.stringify(newData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`localStorage: ${name}`, error);
  }

  localStorage.setItem(name, str);
}

export function setDataInSessionStorage(name: string, data: AnyObject, marge = false): void {
  let newData = data;

  if (marge) {
    const oldData = getDataInSessionStorage(name);

    newData = { ...oldData, ...data };
  }

  let str = '';

  try {
    str = JSON.stringify(newData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`sessionStorage: ${name}`, error);
  }

  sessionStorage.setItem(name, str);
}
